// components/Layout/Topbar/Topbar.jsx
import React, { useEffect, useState } from "react";
import { IoMdMenu } from "react-icons/io";
import { useAuthenticate } from "../../context/AuthContext";
import MenuButton from "./MenuButton";
import SubscriptionBadge from "./SubscriptionBadge";
import NotificationDropdown from "./NotificationDropdown";
import UserDropdown from "./UserDropdown";
import { api_url } from "../../utils/data";
import axios from "axios";

const Topbar = ({ openSidebar, setOpenSidebar }) => {
  const { user, pharmacyDetails, subscriptionDetails, authToken } = useAuthenticate();
  const [dropdown, setDropdown] = useState(false);
  const [notificationDropdown, setNotificationDropdown] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const closeAllDropdowns = () => {
    setDropdown(false);
    setNotificationDropdown(false);
  };

  const getNotifications = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + authToken,
      },
    };
    
    try {
      const response = await axios.get(
        `${api_url}/accounts/notifications?status=unread`,
        config
      );
      setNotifications(response?.data)

    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getNotifications();
  }, []);

  return (
    <header className="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-50">
      <div className="flex items-center justify-between px-4 py-2 max-w-full">
        {/* Left Section */}
        <div className="flex items-center">
          <MenuButton 
            openSidebar={openSidebar} 
            setOpenSidebar={setOpenSidebar} 
          />
        </div>

        {/* Right Section */}
        <div className="flex items-center space-x-4">
          {subscriptionDetails?.success && (
            <>
              <SubscriptionBadge subscriptionDetails={subscriptionDetails} />
              
              {subscriptionDetails?.subscription?.package !== "Alpha" &&
                subscriptionDetails?.subscription?.package !== "Compact" && (
                  <NotificationDropdown
                    notifications={notifications}
                    authToken={authToken}
                    isOpen={notificationDropdown}
                    setIsOpen={setNotificationDropdown}
                    closeOthers={closeAllDropdowns}
                    getNotifications={getNotifications}
                  />
                )}
            </>
          )}
          
          <UserDropdown
            user={user}
            isOpen={dropdown}
            setIsOpen={setDropdown}
            closeOthers={closeAllDropdowns}
          />
        </div>
      </div>
    </header>
  );
};

export default Topbar;